import { render, staticRenderFns } from "./MetricsAndAlerts.vue?vue&type=template&id=0921dc80"
import script from "./MetricsAndAlerts.vue?vue&type=script&lang=js"
export * from "./MetricsAndAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports